import afterEach from './after-each'
import beforeEach from './before-each'
import beforeResolve from './before-resolve'

export default { afterEach, beforeEach, beforeResolve }
